import(/* webpackMode: "eager" */ "/vercel/path0/src/app/campaigns/page.js");
